const normalizeZipCode = (code: string): string => code.replace(/[^a-zA-Z0-9 -]/g, "");

export default normalizeZipCode;
